import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import './CloudSolutionTechnologies.css';

const technologies = {
  "Cloud Platforms": [
    { 
      name: "AWS",
      logo: "/assets/tech-logos/aws.png",
      fallbackLogo: "https://a0.awsstatic.com/libra-css/images/logos/aws_logo_smile_1200x630.png"
    },
    { 
      name: "Azure",
      logo: "/assets/tech-logos/azure.png",
      fallbackLogo: "/assets/tech-logos/azure.svg"
    },
    { 
      name: "Google Cloud",
      logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/googlecloud/googlecloud-original.svg",
      fallbackLogo: "/assets/tech-logos/google-cloud.svg"
    },
    { 
      name: "Oracle Cloud",
      logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/oracle/oracle-original.svg",
      fallbackLogo: "https://www.oracle.com/a/ocom/img/obic-logo-rgb.svg"
    }
  ],
  "Containerization": [
    { 
      name: "Docker",
      logo: "https://www.docker.com/wp-content/uploads/2022/03/vertical-logo-monochromatic.png",
      fallbackLogo: "https://www.docker.com/wp-content/uploads/2022/03/Moby-logo.png"
    },
    { 
      name: "Kubernetes",
      logo: "https://raw.githubusercontent.com/kubernetes/kubernetes/master/logo/logo.svg",
      fallbackLogo: "https://kubernetes.io/images/kubernetes-horizontal-color.png"
    },
    { 
      name: "OpenShift",
      logo: "https://www.redhat.com/cms/managed-files/Logo-Red_Hat-OpenShift-A-Standard-RGB_0.png",
      fallbackLogo: "https://assets.openshift.com/hubfs/images/logos/osh/Logo-Red_Hat-OpenShift-A-Standard-RGB.svg"
    }
  ],
  "DevOps Tools": [
    { 
      name: "Jenkins",
      logo: "https://www.jenkins.io/images/logos/jenkins/jenkins.png",
      fallbackLogo: "https://www.jenkins.io/images/logos/jenkins/256.png"
    },
    { 
      name: "GitLab CI",
      logo: "https://about.gitlab.com/images/press/logo/svg/gitlab-icon-rgb.svg",
      fallbackLogo: "https://about.gitlab.com/images/press/logo/png/gitlab-icon-rgb.png"
    },
    { 
      name: "GitHub Actions",
      logo: "https://github.githubassets.com/images/modules/site/features/actions-icon-actions.svg",
      fallbackLogo: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png"
    },
    { 
      name: "Terraform",
      logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/terraform/terraform-original.svg",
      fallbackLogo: "https://www.vectorlogo.zone/logos/terraformio/terraformio-icon.png"
    }
  ],
  "Monitoring & Logging": [
    { 
      name: "Prometheus",
      logo: "https://raw.githubusercontent.com/cncf/artwork/master/projects/prometheus/horizontal/color/prometheus-horizontal-color.svg",
      fallbackLogo: "https://raw.githubusercontent.com/cncf/artwork/master/projects/prometheus/icon/color/prometheus-icon-color.png"
    },
    { 
      name: "ELK Stack",
      logo: "https://images.contentstack.io/v3/assets/bltefdd0b53724fa2ce/blt280217a63b82a734/6321592d49d5972d3dc26a03/elastic-logo.svg",
      fallbackLogo: "https://www.elastic.co/static-res/images/elastic-logo-200.png"
    },
    { 
      name: "New Relic",
      logo: "https://www.vectorlogo.zone/logos/newrelic/newrelic-icon.svg",
      fallbackLogo: "https://newrelic.com/themes/custom/erno/assets/mediakit/new_relic_logo_horizontal.png"
    },
    { 
      name: "CloudWatch",
      logo: "/assets/tech-logos/aws.png",
      fallbackLogo: "https://d1.awsstatic.com/icons/jp/cloudwatch_icon_60.3f4fd26c9c976a2e0853fed0a4a4ac8e1b5277d0.png"
    }
  ]
};

const CloudSolutionTechnologies = () => {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  const handleImageError = (e, fallbackSrc) => {
    if (e.target.src !== fallbackSrc) {
      e.target.src = fallbackSrc;
    }
  };

  return (
    <Box className="cloud-solutions-section">
      <Container maxWidth="lg">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
        >
          <Typography variant="h2" className="section-title" gutterBottom>
            CLOUD SOLUTIONS
          </Typography>

          {Object.entries(technologies).map(([category, techs]) => (
            <Box key={category} className="technology-category">
              <Typography variant="h4" className="category-title" gutterBottom>
                {category}
              </Typography>
              {/* <Typography variant="subtitle1" className="category-description" gutterBottom>
                {category === "Cloud Platforms" && "Leading cloud service providers"}
                {category === "Containerization" && "Container orchestration and management"}
                {category === "DevOps Tools" && "Automation and continuous delivery"}
                {category === "Monitoring & Logging" && "Observability and analytics"}
              </Typography> */}
              <Grid container spacing={3}>
                {techs.map((tech) => (
                  <Grid item xs={6} sm={4} md={3} lg={2} key={tech.name}>
                    <motion.div variants={itemVariants}>
                      <Paper elevation={2} className="technology-card">
                        <img
                          src={tech.logo}
                          alt={tech.name}
                          className="technology-logo"
                          onError={(e) => handleImageError(e, tech.fallbackLogo)}
                        />
                        <Typography variant="subtitle1" className="technology-name">
                          {tech.name}
                        </Typography>
                      </Paper>
                    </motion.div>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}
        </motion.div>
      </Container>
    </Box>
  );
};

export default CloudSolutionTechnologies; 